const Tickets = () => import(/* webpackChunkName: "serverShift" */ '@/components/tickets')
export default {
    name: 'tickets',
    path: 'todaytickets',
    redirect: '/todaytickets/index',
    meta: {label: 'tickets'},
    component: {
        render (c) { return c('router-view') }
    },
    children: [
        {
            path: 'index',
            meta: {label: 'tickets', auth: [0, 1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12]},
            component: Tickets,
            props: true
        }
    ]
}
